import { LuSquarePen, LuTriangleAlert } from "react-icons/lu";

export default function ProjectSettingsPackageNameConfirmation({
  onCancel,
  onSave,
}: {
  onCancel: () => void;
  onSave: () => void;
}) {
  return (
    <div
      className="w-full h-full p-8
    flex flex-col items-center gap-5"
    >
      <div
        className="flex flex-col items-center gap-2
      text-[#D8C640]"
      >
        <LuTriangleAlert size={80} />
        <p className="text-4xl font-semibold">Warning</p>
      </div>
      <p className="text-center text-light-placeholder dark:text-dark-placeholder">
        If your mobile application has been already published, changing its{" "}
        <strong>package name</strong> will prevent you from updating your
        application.
      </p>
      <div className="flex items-center justify-center gap-5 pt-5">
        <button
          className="text-lg text-light-text dark:text-dark-text
          px-4
        hover:brightness-150 transition-all duration-300"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          id="project-settings-package-name-confirmation-save"
          className="flex items-center gap-3 
        bg-primary-blue px-4 py-1.5 rounded-lg
        text-white text-lg
        hover:brightness-125 transition-all duration-300
        disabled:opacity-50 
        disabled:cursor-not-allowed
        disabled:hover:brightness-100"
          onClick={onSave}
        >
          <LuSquarePen size={16} />
          Save
        </button>
      </div>
    </div>
  );
}
